import { createI18n } from "vue-i18n";
import { strings as enStrings } from "../locales/en/strings";
import { strings as esStrings } from "../locales/es/strings";
import { strings as frStrings } from "../locales/fr/strings";
import { strings as itStrings } from "../locales/it/strings";
import { strings as arStrings } from "../locales/ar/strings";
import { strings as ptStrings } from "../locales/pt/strings";
import { strings as bsStrings } from "../locales/bs/strings";
import { strings as noStrings } from "../locales/no/strings";

import { watch } from "vue";
import { useUserStore } from "@/stores/user.store";
import { getLanguageFromLocale, getBrowserLocale } from "@/utils/locale";

// Get initial locale from localStorage or browser default
const getInitialLocale = () => {
  return getLanguageFromLocale(getBrowserLocale());
};

export const i18n = createI18n({
  legacy: false, // Set to false to use Composition API
  locale: getInitialLocale(),
  fallbackLocale: "en",
  messages: {
    en: enStrings,
    es: esStrings,
    fr: frStrings,
    ar: arStrings,
    it: itStrings,
    pt: ptStrings,
    bs: bsStrings,
    no: noStrings,
  },
});

// Setup watchers after app is mounted
export const setupI18nWatchers = () => {
  const userStore = useUserStore();

  // Watch for locale changes from user preferences
  watch(
    () => userStore.userLocale,
    (newLocale) => {
      if (newLocale) {
        let language = getLanguageFromLocale(newLocale);

        // if language not in availableLocales, fallback to en
        if (!availableLocales.some((locale) => locale.code === language)) {
          language = "en";
        }

        i18n.global.locale.value = language as
          | "en"
          | "es"
          | "fr"
          | "ar"
          | "it"
          | "pt"
          | "bs"
          | "no";
        localStorage.setItem("locale", language);
      }
    },
  );

  // Watch for direct locale changes (e.g., from language switcher)
  watch(
    () => i18n.global.locale.value,
    (newLocale) => {
      if (newLocale) {
        localStorage.setItem("locale", newLocale);
      }
    },
  );
};

export const availableLocales = [
  { code: "en", name: "English" },
  { code: "es", name: "Español" },
  { code: "fr", name: "Français" },
  { code: "ar", name: "العربية" },
  { code: "it", name: "Italiano" },
  { code: "pt", name: "Português" },
  { code: "bs", name: "Bosanski" },
  { code: "no", name: "Norsk" },
];
